import styled from 'styled-components/macro'
import minus from '../../../assets/svg/minus.svg'
import plus from '../../../assets/svg/plus.svg'

export const ProductCounter = styled.div`
  display: flex;
  color: #222;
  margin: 0 8px 24px 0;

  button {
    white-space: nowrap;
    transition-property: background-color;
    transition-duration: 0.2s;
    text-size-adjust: 100%;
    position: relative;
    padding: 0;
    margin: 0;
    line-height: 40px;
    width: 40px;
    letter-spacing: 2px;
    font-weight: 400;
    font-size: 14px;
    background-color: hsla(0, 0%, 100%, 0);
    border: none;
    box-shadow: inset 0 0 0 1px var(--m-color-border, #aaa);

    outline: none;
    background-size: 5000%;
    background-position: 50%;
    &:disabled {
      opacity: 0.3;
    }
    div {
      background-repeat: no-repeat;
      background-position: 50%;
      background-size: 32px 23px;
      width: 100%;
      height: 100%;
    }
    div.plus {
      background-image: url(${plus});
    }
    div.minus {
      background-image: url(${minus});
    }
  }

  input {
    text-size-adjust: 100%;
    text-align: center;
    padding: 8px;
    outline-style: none;
    margin: 0;
    line-height: 21px;
    height: 40px;
    font-size: 14px;
    width: 64px;
    border-radius: 0px;
    box-shadow: inset 0 0 0 1px var(--m-color-border, #aaa);
    border: none;
  }

  p {
    margin: 0;
    padding-left: 8px;
    text-decoration: underline;
    align-self: end;
  }
`
